import React, { useState, useEffect } from 'react';
import { makeStyles, Box, Typography, IconButton, Button, TextField } from '@material-ui/core';
import { InsertDriveFile } from '@material-ui/icons';
import { useTranslate, useDataProvider, usePermissions } from 'react-admin';
import CustomPoper from '../CustomizedUIs/CustomPoperCalendar';
import GreenSwitch from '../CustomizedUIs/GreenSwitch';
import CustomTextField from '../CustomizedUIs/CustomTextFieldWithFontSize';
import OneLineTextField from '../CustomizedUIs/CustomTextFiled';
import icBlueAdd from '../assets/icons/primary-blue-bin.png';
import icAttachment from '../assets/icons/ic_attachment.png';
import { isMedia, LIST_INPUT, GENERIC_MEDIA_ITEM_INPUT } from '../utils';
import DialogChooseFile from '../file-management/file-management-dialog';
import { useSelector, useDispatch } from 'react-redux';
import { changeNodeGlobalData } from '../redux/actions/tree-action';
import SelectBoxFilter from '../common/select-box-filter';
import Autocomplete from '@material-ui/lab/Autocomplete';
import ThumbnailIcon from './thumbnail';


const useStyles = makeStyles(theme => ({

    Title: {
        fontFamily: 'UniviaPro-Medium',
        fontStyle: 'normal',
        fontStretch: 'normal',
        fontWeight: 500,
        lineHeight: '13.2px',
        letterSpacing: 'normal',
        color: '#4f5064',
        fontSize: '11px',
        align: 'center'
    },
    borderCard: {
        borderRadius: '4px',
        backgroundColor: 'rgba(255,255,255,0.5)',
        // opacity: 0.5,
        border: "solid 1px #c1e5fa",
        width: '500px',
        // height: '132px',
        marginTop: '18px'
    },
    titleNodeType: {
        fontFamily: 'UniviaPro-Medium',
        fontStyle: 'normal',
        fontStretch: 'normal',
        fontWeight: 500,
        lineHeight: '13.2px',
        letterSpacing: 'normal',
        color: '#4f5064',
        fontSize: '11px',
    },
    TexTSelect: {
        fontFamily: 'UniviaPro',
        fontSize: '13px',
        fontWeight: 'normal',
        fontStretch: 'normal',
        fontStyle: 'normal',
        lineHeight: '24px',
        letterSpacing: '0.13px',
        color: '#4f5064',
    },
    boxBoder: {
        borderBottom: '1px solid',
        borderRight: '1px solid',
        borderBottomColor: '#f3f7fa',
        borderRightColor: '#f3f7fa',
    },
    switch: {
        width: 170,
        height: 30,
        backgroundColor: theme.palette.common.white,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-around',
        // marginLeft: '24px'
    },
    switchText: {
        whiteSpace: 'nowrap',
        fontFamily: "UniviaPro-Bold",
        fontSize: "9px",
        fontWeight: "bold",
        fontStretch: "normal",
        fontStyle: "normal",
        lineHeight: '11px',
        letterSpacing: " 0.36px",
        color: "#4f5064",
    },
    inputMulti: {
        width: '500px',
        borderRadius: '2px',
        // '&$input': {
        //     width: 385
        // },
    },
    inputPopper: {
        alignSelf: 'flex-end',
        position: 'absolute',
        right: '16px',
        top: '20px'
    },
    borderBrowse: {
        borderRadius: '4px',
        backgroundColor: 'rgba(255,255,255,0.5)',
        // opacity: 0.5,
        border: "solid 1px #c1e5fa",
        width: '500px',
        // height: '132px',
        marginTop: '18px'
    },
    btnAdd: {
        padding: 5,
        minWidth: 'unset',
        width: 25,
        height: 25,
        backgroundColor: '#ffffff',
        borderRadius: 10,
        border: 'solid 2px #e5f1f8;',
    },
    btn: {
        fontFamily: 'UniviaPro-Bold',
        fontStyle: 'normal',
        fontStretch: 'normal',
        fontWeight: 'normal',
        lineHeight: '11px',
        letterSpacing: '0.36px',
        color: '#ffffff',
        fontSize: '9px',
        textAlign: 'center'
    },

    btnIcon: {
        width: 14,
        height: 14
    },
    NameImage: {
        fontFamily: 'UniviaPro',
        fontSize: '13px',
        fontWeight: 'normal',
        fontStretch: 'normal',
        fontStyle: 'normal',
        lineHeight: '16.3px',
        letterSpacing: '0.13px',
        color: '#4f5064',
        maxWidth: 250,
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap'
    },
    SizeImage: {
        marginLeft: 20,
        fontFamily: 'UniviaPro',
        fontSize: '11px',
        fontWeight: 500,
        fontStretch: 'normal',
        fontStyle: 'normal',
        lineHeight: '12.2px',
        letterSpacing: 'normal',
        color: '#88898c',
    },
    textLabel: {
        marginBottom: 8,
        fontFamily: 'UniviaPro',
        fontSize: '13px',
        fontWeight: 'normal',
        fontStretch: 'normal',
        fontStyle: 'normal',
        lineHeight: 'normal',
        letterSpacing: '0.13px',
        color: '#88898c',
        paddingLeft: '16px'
    },
    textLableError: {
        marginBottom: 8,
        fontFamily: 'UniviaPro',
        fontSize: '13px',
        fontWeight: 'normal',
        fontStretch: 'normal',
        fontStyle: 'normal',
        lineHeight: 'normal',
        letterSpacing: '0.13px',

    },
    focuses: {
        backgroundColor: 'white !important'
    },
    underline: {
        '&::before': {
            borderBottom: '1px solid black'
        },
        '&:hover:before': {
            borderBottom: '1px solid black'
        }
    },
    input: {
        backgroundColor: 'white',
        borderRadius: '2px',
        "&:hover": {
            backgroundColor: 'white'
        }, fontFamily: 'UniviaPro',
        fontSize: '13px',
        fontWeight: 'normal',
        fontStretch: 'normal',
        fontStyle: 'normal',
        lineHeight: '24px',
        letterSpacing: '0.13px',
        color: '#4f5064',
        paddingLeft: '16px',
        "& input::-webkit-clear-button, & input::-webkit-outer-spin-button, & input::-webkit-inner-spin-button": {
            display: "none"
        },
        "& input": {
            "-moz-appearance": "textfield"
        }
    },
    optionText: {
        fontFamily: 'UniviaPro',
        fontSize: '13px',
        fontWeight: 'normal',
        fontStretch: 'normal',
        fontStyle: 'normal',
        lineHeight: '24px',
        letterSpacing: '0.13px',
        color: '#4f5064',
    },
    paper: {
        borderRadius: '2px',
        borderBottom: '1px solid',
        borderRight: '1px solid',
        borderBottomColor: theme.palette.grey['200'],
        borderRightColor: theme.palette.grey['200'],
    },
    endAdornment: {
        display: 'none'
    },
}));

function getInputDeviceLabel(id, translate) {
    const foundItem = LIST_INPUT.find(item => item.id === id);
    return foundItem ? translate(foundItem.label) : '';
}

function GenericMedia() {
    const classes = useStyles();
    const translate = useTranslate();
    const dataProvider = useDataProvider();
    const { permissions, loaded } = usePermissions();
    const dispatch = useDispatch();

    const LIST_INPUT_DEVICE = LIST_INPUT.map(item => ({
        ...item,
        label: translate(item.label)
    }));

    const [openPoper, setOpenPopper] = useState(false);
    const [openFile, setOpenFile] = useState({
        status: false,
        defaultId: 1,
        format: '',
        setResponse: null
    });
    const [loading, setLoading] = useState(false);
    const [listInfoChannel, setListInfoChannel] = useState([]);
    const [textValue, setTextValue] = useState(null);
    const { isEditing, nodeSelected } = useSelector(state => state.tree);

    const {
        isUSBPowerControl, hasInfoMessage, message, title, inputDevice, channelId, media, USBPath
    } = nodeSelected.applicationData.nodeApplication.genericMediaItem;

    const handleOpenFileDialog = () => {
        setOpenFile({
            status: true,
            defaultId: 6,
            format: isMedia,
            setResponse: onChangeValue('media')
        });
    }

    const handleClose = () => {
        setOpenFile({
            status: false,
            defaultId: 1,
            format: '',
            setResponse: null
        })
    }

    const onChangeValue = prop => value => {
        const newNode = {
            ...nodeSelected.applicationData,
            nodeApplication: {
                ...nodeSelected.applicationData.nodeApplication,
                genericMediaItem: {
                    ...nodeSelected.applicationData.nodeApplication.genericMediaItem,
                    [prop]: value
                }
            }
        }
        dispatch(changeNodeGlobalData(newNode));
    }

    const onChangeCheckbox = prop => event => {
        onChangeValue(prop)(event.target.checked);
    }

    const onChangeMessageText = event => {
        onChangeValue('message')({
            text: event.target.value,
            fontSize: message.fontSize
        });
    }

    const onChangeMessageFontSize = fontSize => {
        onChangeValue('message')({
            text: message.text,
            fontSize
        });
    }

    const onChangeInputDevice = input => {
        onChangeValue('inputDevice')(input.id);
    }

    const onChangeTextValue = prop => event => {
        onChangeValue(prop)(event.target.value);
    }

    const textOnChange = (event, values) => {
        setTextValue(values)
        const newNode = {
            ...nodeSelected.applicationData,
            nodeApplication: {
                ...nodeSelected.applicationData.nodeApplication,
                genericMediaItem: {
                    ...nodeSelected.applicationData.nodeApplication.genericMediaItem,
                    channelId: values ? parseInt(values.split('-')[0]) : null
                }
            }
        }
        dispatch(changeNodeGlobalData(newNode));
    }

    const getInfoChannel = () => {
        setLoading(true)
        dataProvider('GET_LIST', 'infochannels', {
            filter: {},
            pagination: {},
            sort: { field: 'createdAt', order: 'DESC' },
        }).then(({ data }) => {
            if (data.length > 0) {
                data.map(item => {
                    item.title = `${item.id} - ${item.name}`
                })
                for (let i = 0; i < data.length; i++) {
                    if (channelId && data[i].id === channelId) {
                        setTextValue(data[i].title)
                        break
                    }
                    else
                        setTextValue(null)
                }
            }
            setListInfoChannel(data)
            setLoading(false)
        }).catch(error => {
            setLoading(true)
            console.log('@@@ getData ERROR', error)
        });
    }

    const setDefaultInputDevice = () => {
        if (!inputDevice) {
            onChangeInputDevice(LIST_INPUT_DEVICE[0]);
        }
    }

    const getFile = () => {
        if (media) {
            dataProvider('GET_ONE', 'categories', {
                id: media.id
            }).then(({ data }) => {
                if (data) {
                    const newNode = {
                        ...nodeSelected.applicationData,
                        nodeApplication: {
                            ...nodeSelected.applicationData.nodeApplication,
                            genericMediaItem: {
                                ...nodeSelected.applicationData.nodeApplication.genericMediaItem,
                                media: data
                            }
                        }
                    }
                    dispatch(changeNodeGlobalData(newNode, nodeSelected.id));
                }
                else {
                    const newNode = {
                        ...nodeSelected.applicationData,
                        nodeApplication: {
                            ...nodeSelected.applicationData.nodeApplication,
                            genericMediaItem: {
                                message: nodeSelected.applicationData.nodeApplication.genericMediaItem.message,
                                isUSBPowerControl: nodeSelected.applicationData.nodeApplication.genericMediaItem.isUSBPowerControl,
                                hasInfoMessage: nodeSelected.applicationData.nodeApplication.genericMediaItem.hasInfoMessage,
                                title: nodeSelected.applicationData.nodeApplication.genericMediaItem.title,
                                channelId: nodeSelected.applicationData.nodeApplication.genericMediaItem.channelId,
                                USBPath: nodeSelected.applicationData.nodeApplication.genericMediaItem.USBPath,
                                inputDevice: nodeSelected.applicationData.nodeApplication.genericMediaItem.inputDevice,
                            }
                        }
                    };
                    dispatch(changeNodeGlobalData(newNode, nodeSelected.id));
                }
            }).catch(error => {
                console.log('GET FILE ERROR:', error);
            });
        }
    }

    useEffect(() => {
        getFile();
        getInfoChannel();
        setDefaultInputDevice();
    }, []);

    useEffect(() => {
        if (listInfoChannel.length > 0) {
            for (let i = 0; i < listInfoChannel.length; i++) {
                if (channelId && listInfoChannel[i].id === channelId) {
                    setTextValue(listInfoChannel[i].title)
                    break
                }
                else
                    setTextValue(null)
            }
        }
    }, [nodeSelected]);

    if (loading || !loaded) return null;
    return (
        <Box>
            <Box px={1} className={classes.switch} style={{ marginTop: 25, position: 'relative' }}>
                <Typography className={classes.switchText}>{translate('resources.infoPage.genericMedia.usb_power_control')}</Typography>
                <GreenSwitch
                    checked={isUSBPowerControl}
                    disabled={!isEditing}
                    size='small'
                    style={{ color: 'white' }}
                    onChange={onChangeCheckbox('isUSBPowerControl')}
                />
            </Box>
            <Box px={1} className={classes.switch} style={{ marginTop: 15, position: 'relative' }}>
                <Typography className={classes.switchText} style={{ marginRight: 35 }}>{translate('resources.infoPage.genericMedia.info_message')}</Typography>
                <GreenSwitch
                    checked={hasInfoMessage}
                    disabled={!isEditing}
                    size='small'
                    style={{ color: 'white' }}
                    onChange={onChangeCheckbox('hasInfoMessage')}
                />
            </Box>
            {
                hasInfoMessage && (
                    <Box style={{ marginTop: 20 }} >
                        <CustomTextField
                            disabled={!isEditing}
                            className={classes.inputMulti}
                            id="textfield-message"
                            multiline
                            rows={4}
                            value={message.text}
                            onChange={onChangeMessageText}
                            placeholder={translate(`pos.messages.placeholder`)}
                            fontSize={message.fontSize}
                            setFontSize={onChangeMessageFontSize}
                            infoPage
                            endDom={
                                <Box className={classes.inputPopper}>
                                    <CustomPoper
                                        color={'#e5f1f8'}
                                        fontSize={'11px'}
                                        open={openPoper}
                                        handleClick={() => setOpenPopper(true)}
                                        handleClose={() => setOpenPopper(false)}
                                        title={translate(`pos.messages.constent`)}
                                        content={translate(`pos.messages.constentContent`)}
                                        icon={<b>?</b>}
                                    />
                                </Box>
                            }
                        />
                    </Box>
                )
            }
            <Box style={{ marginTop: 20 }} >
                <OneLineTextField
                    disabled={!isEditing}
                    id="filled-basic"
                    label={translate(`resources.infoPage.genericMedia.title`)}
                    value={title}
                    onChange={onChangeTextValue('title')}
                    style={{ width: 500 }}
                    endDom={<CustomPoper
                        color={'#e5f1f8'}
                        fontSize={'11px'}
                        open={openPoper}
                        handleClick={() => setOpenPopper(true)}
                        handleClose={() => setOpenPopper(false)}
                        title={translate(`pos.common.title`)}
                        content={translate(`pos.common.contentTitle`)}
                        icon={<b>?</b>}
                    />}
                />
            </Box>
            <Box style={{ width: 500, marginTop: 20 }} >
                <SelectBoxFilter
                    disabled={!isEditing}
                    data={LIST_INPUT_DEVICE}
                    label={translate(`resources.infoPage.genericMedia.select_input_device`)}
                    value={getInputDeviceLabel(inputDevice, translate)}
                    onChange={(value) => onChangeInputDevice(value)}
                    keyName='label'
                    placeholder={translate('resources.infoPage.filter_input_device')}
                />

            </Box>
            {
                inputDevice === GENERIC_MEDIA_ITEM_INPUT.INFO_CHANNEL && (
                    <Box borderRadius='2px'>
                        <Box style={{ marginTop: 20 }}>
                            <Autocomplete
                                classes={{
                                    option: classes.optionText,
                                    paper: classes.paper,
                                    endAdornment: classes.endAdornment,
                                    noOptions: classes.optionText
                                }}
                                style={{ maxWidth: 500 }}
                                disabled={!isEditing}
                                id="auto-complete-info-channel"
                                options={listInfoChannel.map((option) => option.title)}
                                onChange={textOnChange}
                                value={textValue}
                                defaultValue={null}
                                renderInput={(params) => (
                                    <TextField
                                        {...params}
                                        label={translate('resources.infoPage.slideShow.infoChannelId')}
                                        margin="normal"
                                        variant="filled"
                                        InputLabelProps={{
                                            classes: {
                                                root: classes.textLabel,
                                                error: classes.textLableError
                                            }
                                        }}
                                        InputProps={{
                                            ...params.InputProps,
                                            className: `${classes.input}`,
                                            classes: {
                                                underline: classes.underline,
                                                focused: classes.focuses
                                            }
                                        }}
                                    />
                                )}
                            />
                        </Box>
                    </Box>
                )
            }
            {
                inputDevice === GENERIC_MEDIA_ITEM_INPUT.MEDIA_FILE && (
                    <Box className={classes.borderBrowse} justifyContent='center' alignItems="center" >
                        <Box display='flex' width="100%" alignItems="center">
                            <Box mx={2} display='flex' alignItems="center">
                                <IconButton
                                    variant="outlined"
                                    color='primary'
                                    style={{ marginRight: '10px', padding: 'unset' }}
                                >
                                    <img src={icAttachment} width={27} />
                                </IconButton>
                                <Typography className={classes.Title}>{translate('pos.channels.mediaFile')}</Typography>
                            </Box>
                            <Box style={{ marginLeft: 'auto' }} mx={2} my={2}>
                                <Button onClick={handleOpenFileDialog} variant='contained' color='primary' disabled={!isEditing}>
                                    {media ? translate('pos.common.change') : translate('pos.common.browse')}
                                </Button>
                                <DialogChooseFile
                                    formats={openFile.format}
                                    defaultId={openFile.defaultId}
                                    open={openFile.status}
                                    pickerMode='pickMediaOnly'
                                    handleClose={handleClose}
                                    setChooseValue={openFile.setResponse}
                                    isPermission={permissions.functionAction.find((value) => value.function === 'File manager (CRUD)' && (value.isRead || value.isUpdate))}
                                />

                            </Box>
                        </Box>
                        <ThumbnailIcon thumbnail={media} onClear={() => onChangeValue('media')(null)} />

                    </Box>
                )
            }
        </Box>
    )
}

export default GenericMedia;
